export default function BrandAdvantage() {
  const advantages = [
    {
      icon: 'ri-shield-check-line',
      title: '品质保障',
      desc: '每件产品均通过SGS/FDA等国际安全认证，严格选品流程，确保安全无忧。',
    },
    {
      icon: 'ri-eye-off-line',
      title: '隐私配送',
      desc: '无标识隐私包装，快递面单无敏感信息，全程保密配送，守护您的隐私。',
    },
    {
      icon: 'ri-vip-crown-line',
      title: '专业选品',
      desc: '资深选品团队全球甄选，只推荐经过实测验证的优质产品，品质值得信赖。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '贴心服务',
      desc: '7×24小时在线客服，专业顾问一对一解答，售后无忧，购物更安心。',
    },
  ];

  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-secondary-500 tracking-[0.2em] uppercase mb-2">
            Why Choose Us
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            为什么选择臻品阁
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-md mx-auto">
            四大核心优势，为您打造安心的精品购物体验
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {advantages.map((item) => (
            <div
              key={item.title}
              className="text-center p-5 md:p-6 rounded-lg bg-background-100/70 border border-background-200/40 hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 flex items-center justify-center rounded-full bg-primary-100/70">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-600`} />
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}